import React, { useEffect, useState } from "react";
import {
  CompanyManageGetAutoStock,
  CompanyManageMyStore,
  PriceListPrice,
} from "../../Api/Services";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import imgPlus from "../../assets/Icon/execution.png";
import mixing from "../../assets/Icon/icons8-mixing-panel-24.png";
import { toast } from "react-toastify";
import InputCus from "../../Component/InputCus/Text/InputCus";

function ListPrice() {
  const [Data, setData] = useState([]);
  const [MyStore, setMyStore] = useState();
  const [MyStoreId, setMyStoreId] = useState();
  const [isLoading, setLoading] = useState(true);
  const jalaali = require("jalaali-js");
  const [Product, setProduct] = useState("");
  const [Errors, setErrors] = useState([]);

  const start = async () => {
    try {
      let ErrorList = [];

      const CompanyManageMyStoreData = await CompanyManageMyStore();
      if (
        CompanyManageMyStoreData.status &&
        CompanyManageMyStoreData.status === 200
      ) {
        setMyStore(CompanyManageMyStoreData.data.data);
        for (const item of CompanyManageMyStoreData.data.data) {
          const CompanyManageGetAutoStockData = await CompanyManageGetAutoStock(
            item.companyStoreId,
          );
          if (
            CompanyManageGetAutoStockData.status &&
            CompanyManageGetAutoStockData.status === 200
          ) {
            ErrorList.push(...CompanyManageGetAutoStockData.data.data);
            if (CompanyManageGetAutoStockData.data.isSuccess) {
              toast.success(
                ` ارتباط با انبار برای موجودی برقرار شد
                    ${item.companyStoreCompanyName} ${item.companyStoreName}`,
              );
            }
          }
        }
        setErrors(ErrorList);

        if (CompanyManageMyStoreData.data.data.length > 0) {
          let id = CompanyManageMyStoreData.data.data[0].companyStoreId;
          setMyStoreId(id);
          const PriceListPriceData = await PriceListPrice(id);
          if (PriceListPriceData.status && PriceListPriceData.status === 200) {
            setData(PriceListPriceData.data.data.data);
          }
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClickStore = async (id) => {
    setLoading(true);
    try {
      const PriceListPriceData = await PriceListPrice(id);
      if (PriceListPriceData.status && PriceListPriceData.status === 200) {
        setData(PriceListPriceData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  function copyText() {
    const groupedByBrand = {};
    for (const item of Data) {
      const brand = item.productProductBerandName?.trim() || "Other";
      if (!groupedByBrand[brand]) groupedByBrand[brand] = [];
      groupedByBrand[brand].push(item);
    }

    let output = "";
    for (const brand of Object.keys(groupedByBrand)) {
      output += `✅️${brand}✅️\n\n`;

      const sorted = groupedByBrand[brand].sort(
        (a, b) => a.productOrder - b.productOrder,
      );

      const groupedByModel = {};
      for (const p of sorted) {
        const modelKey = [
          p.productProductSeriesName != " " && p.productProductSeriesName,

          p.productSymbol,

          p.productProductSeriesEndName != " "
            ? p.productProductSeriesEndName + " "
            : " ",

          p.productProductRamName != " " && p.productProductRamName + "/",

          p.productProductRomName != " " && p.productProductRomName + " ",

          p.productProductNetworkName != " " &&
            p.productProductNetworkName + " ",

          p.productProductCountryName != " " &&
            p.productProductCountryName + " ",

          p.productIsInsurance && "بیمه",
        ]
          .filter(Boolean)
          .join("");

        // const modelKey =
        //   p.productProductTypeName?.trim() +
        //   p.productProductSeriesName?.trim() +
        //   p.productSymbol?.trim() +
        //   p.productProductSeriesEndName?.trim() +
        //   (p.productProductRamName
        //     ? p.productProductRamName.trim() + "/"
        //     : "") +
        //   p.productProductRomName?.trim() +
        //   p.productProductNetworkName?.trim() +
        //   p.productProductCountryName?.trim() +
        //   (p.productIsInsurance ? "بیمه" : "");

        if (!groupedByModel[modelKey]) groupedByModel[modelKey] = [];
        groupedByModel[modelKey].push(p);
      }

      for (const modelKey of Object.keys(groupedByModel)) {
        output += `📱${brand} ${modelKey}\n`;
        for (const p of groupedByModel[modelKey]) {
          const color = p.productProductColorName;
          const price = p.price
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          output += `${color} ${price}\n`;
        }
        output += `\n`;
      }
    }

    const textToCopy = output.trim();

    const textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);

    toast.success("متن با موفقیت کپی شد");
  }

  useEffect(() => {
    start();
  }, []);

  const handleDownload = () => {
    const wb = XLSX.utils.book_new();
    const datas = Data.map((item) => ({
      "Product Name": [
        item.productProductBerandName != " " &&
          item.productProductBerandName + " ",

        item.productProductTypeName != " " && item.productProductTypeName + " ",

        item.productProductSeriesName != " " && item.productProductSeriesName,

        item.productSymbol,

        item.productProductSeriesEndName != " "
          ? item.productProductSeriesEndName + " "
          : " ",

        item.productProductRamName != " " && item.productProductRamName + "/",

        item.productProductRomName != " " && item.productProductRomName + " ",

        item.productProductNetworkName != " " &&
          item.productProductNetworkName + " ",

        item.productProductCountryName != " " &&
          item.productProductCountryName + " ",

        item.productProductColorName != " " &&
          item.productProductColorName + " ",

        item.productIsInsurance && "بیمه",
      ]
        .filter(Boolean)
        .join(""),

      Price: (item.price + "000")
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ","),

      Stock: item.stock,
    }));
    const ws = XLSX.utils.json_to_sheet(datas);

    const date = new Date(Data[0].createdDate.replace("T", " "));
    const jalaaliDate = jalaali.toJalaali(date);
    const year = jalaaliDate.jy;
    const month = jalaaliDate.jm.toString().padStart(2, "0");
    const day = jalaaliDate.jd.toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    const jalaaliDateString = `${year}-${month}-${day} ${hours}--${minutes} By Color ${Data[0].companyStore.name}`;

    XLSX.utils.book_append_sheet(wb, ws, jalaaliDateString);

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, jalaaliDateString + ".xlsx");
  };

  const handleDownloadMinMax = () => {
    const wb = XLSX.utils.book_new();

    // Group data by product properties except color and price
    const grouped = {};

    Data.forEach((item) => {
      const key =
        item.productProductBerandName +
        "|" +
        item.productProductTypeName +
        "|" +
        item.productProductSeriesName +
        "|" +
        item.productSymbol +
        "|" +
        item.productProductSeriesEndName +
        "|" +
        item.productProductRomName +
        "|" +
        item.productProductRamName +
        "|" +
        item.productIsInsurance +
        "|" +
        item.productProductNetworkName +
        "|" +
        item.productProductCountryName;

      if (!grouped[key]) {
        grouped[key] = {
          prices: [],
          totalStock: 0,
        };
      }

      grouped[key].prices.push(item.price);
      grouped[key].totalStock += item.stock || 0;
    });

    // Generate Excel-friendly data
    const datas = Object.entries(grouped).map(
      ([key, { prices, totalStock }]) => {
        const [
          Berand,
          Type,
          SeriesName,
          Symbol,
          SeriesEnd,
          Rom,
          Ram,
          IsInsurance,
          Network,
          Country,
        ] = key.split("|");

        const min = Math.min(...prices);
        const max = Math.max(...prices);

        const productName = [
          Berand !== " " && Berand + " ",
          Type !== " " && Type + " ",
          SeriesName !== " " && SeriesName,
          Symbol,
          SeriesEnd !== " " ? SeriesEnd + " " : " ",
          Ram !== " " && Ram + "/",
          Rom !== " " && Rom + " ",
          Network !== " " && Network + " ",
          Country !== " " && Country + " ",
          IsInsurance === "true" && "بیمه",
        ]
          .filter(Boolean)
          .join("");

        return {
          "Product Name": productName,
          "Min Price": (min + "000").replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          "Max Price": (max + "000").replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          Stock: totalStock,
        };
      },
    );

    const ws = XLSX.utils.json_to_sheet(datas);
    const date = new Date(Data[0].createdDate.replace("T", " "));
    const jalaaliDate = jalaali.toJalaali(date);
    const year = jalaaliDate.jy;
    const month = jalaaliDate.jm.toString().padStart(2, "0");
    const day = jalaaliDate.jd.toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    const jalaaliDateString = `${year}-${month}-${day} ${hours}--${minutes} MinAndMax ${Data[0].companyStore.name}`;

    XLSX.utils.book_append_sheet(wb, ws, jalaaliDateString);

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, jalaaliDateString + ".xlsx");
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-center align-item-center flex-column">
            {Errors.map((item) => (
              <p>{item}</p>
            ))}
          </div>
          <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
            <div className="d-flex justify-content-between align-items-center">
              {MyStore &&
                MyStore.map((item, key) => (
                  <div className="border border-3 border-black m-2 rounded">
                    {Data?.[0]?.companyStoreId == item.companyStoreId && (
                      <>
                        <button
                          onClick={() => {
                            copyText();
                          }}
                          className="m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2"
                        >
                          📋 کپی متن
                        </button>
                        <button
                          className={"m-2 border-0 rounded bg-warning pointer"}
                          onClick={() => {
                            handleDownload(item.companyStoreId);
                          }}
                        >
                          <img height={40} src={imgPlus} alt="" />
                        </button>
                        <button
                          className={"m-2 border-0 rounded bg-warning pointer"}
                          onClick={() => {
                            handleDownloadMinMax(item.companyStoreId);
                          }}
                        >
                          <img height={40} src={mixing} alt="" />
                        </button>
                        <span className="m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2">
                          {(() => {
                            const date = new Date(
                              Data[0].createdDate.replace("T", " "),
                            );
                            const jalaaliDate = jalaali.toJalaali(date);
                            const year = jalaaliDate.jy;
                            const month = jalaaliDate.jm
                              .toString()
                              .padStart(2, "0");
                            const day = jalaaliDate.jd
                              .toString()
                              .padStart(2, "0");
                            const hours = date
                              .getHours()
                              .toString()
                              .padStart(2, "0");
                            const minutes = date
                              .getMinutes()
                              .toString()
                              .padStart(2, "0");
                            const seconds = date
                              .getSeconds()
                              .toString()
                              .padStart(2, "0");

                            return `${hours}:${minutes}:${seconds} ${year}/${month}/${day}`;
                          })()}
                        </span>
                      </>
                    )}
                    <button
                      onClick={() => {
                        handleClickStore(item.companyStoreId);
                      }}
                      className={`m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2 ${
                        MyStoreId == item.companyStoreId ? "bg-warning" : ""
                      }`}
                    >
                      {item.companyStoreCompanyName +
                        " ( " +
                        item.companyStoreName +
                        " ) "}
                    </button>
                  </div>
                ))}
            </div>
            <div className="d-flex">
              <InputCus
                className="m-2"
                type="text"
                name="name"
                id="name"
                text="نام"
                value={Product}
                onChange={(e) => {
                  setProduct(e.target.value);
                }}
              />
            </div>
            {Data?.length > 0 && (
              <div className="d-flex justify-content-center align-items-center w-100 tableC">
                <table className="table" style={{ lineHeight: "normal" }}>
                  <thead className="sticky-header">
                    <tr className="trTable">
                      <th>نام کالا</th>
                      <th>رنگ</th>
                      <th>تعداد</th>
                      <th>قیمت</th>
                      <th>قیمت روز قبل</th>
                    </tr>
                  </thead>
                  <tbody className="identitystyle">
                    {Data.filter((itemPro) => {
                      const productFilter = Product?.toUpperCase?.() || "";
                      const Pro = [
                        itemPro.productProductBerandName != " " &&
                          itemPro.productProductBerandName + " ",

                        itemPro.productProductTypeName != " " &&
                          itemPro.productProductTypeName + " ",

                        itemPro.productProductSeriesName != " " &&
                          itemPro.productProductSeriesName,

                        itemPro.productSymbol,

                        itemPro.productProductSeriesEndName != " "
                          ? itemPro.productProductSeriesEndName + " "
                          : " ",

                        itemPro.productProductRamName != " " &&
                          itemPro.productProductRamName + "/",

                        itemPro.productProductRomName != " " &&
                          itemPro.productProductRomName + " ",

                        itemPro.productProductNetworkName != " " &&
                          itemPro.productProductNetworkName + " ",

                        itemPro.productProductCountryName != " " &&
                          itemPro.productProductCountryName + " ",

                        itemPro.productIsInsurance && "بیمه",
                      ]
                        .filter(Boolean)
                        .join("")
                        .toUpperCase();
                      return Pro.includes(productFilter);
                    }).map((itemPro, keyPro) => (
                      <tr key={keyPro}>
                        <td>
                          {itemPro.productProductTypeName != " " &&
                            itemPro.productProductTypeName + " "}
                          {itemPro.productProductSeriesName != " " &&
                            itemPro.productProductSeriesName}
                          {itemPro.productSymbol}
                          {itemPro.productProductSeriesEndName != " "
                            ? itemPro.productProductSeriesEndName + " "
                            : " "}
                          {itemPro.productProductRamName != " " &&
                            itemPro.productProductRamName + "/"}
                          {itemPro.productProductRomName != " " &&
                            itemPro.productProductRomName + " "}
                          {itemPro.productProductNetworkName != " " &&
                            itemPro.productProductNetworkName + " "}
                          {itemPro.productProductCountryName != " " &&
                            itemPro.productProductCountryName + " "}
                          {itemPro.productIsInsurance && "بیمه"}
                        </td>
                        <td>{itemPro.productProductColorName}</td>
                        <td>{itemPro.stock}</td>
                        <td>
                          {itemPro.price
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                        </td>
                        <td>
                          {itemPro.lastPrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListPrice;
